import { render, staticRenderFns } from "./ProcessesTable.vue?vue&type=template&id=6a8265a3&"
import script from "./ProcessesTable.vue?vue&type=script&lang=js&"
export * from "./ProcessesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports